// Constants
import {
  buttonType,
  defaultFontFamilyBold,
  maxBorderRadius,
  primaryColor,
  secondaryColor,
  textColorDark,
  transparent,
  textColorLight,
  defaultButtonWidth,
  defaultButtonHeight
} from "@/src/constants/Common";
// Types
import { ButtonProps } from "@/src/types/button";
// Mantine
import { Button as MantineButton, Image, Box } from "@mantine/core";

// TODO: Update temporary colors
const defaultDisabledBackgroundColor = '#D3D3D3'
const defaultDisabledTextColor = '#999999'

const Button = (props: ButtonProps) => {
  const getStyleByVariant = () => {
    const variant = props.variant || buttonType.FILLED;
    const baseStyle = getBaseStyle();
    switch (variant) {
      case buttonType.FILLED: return baseStyle;
      case buttonType.OUTLINED:
        baseStyle.backgroundColor = textColorDark;
        baseStyle.color = props.disabled ? defaultDisabledTextColor : props.color || primaryColor;
        baseStyle.borderColor = props.disabled ? defaultDisabledTextColor : props.color || primaryColor;
        baseStyle.borderWidth = 1;
        baseStyle.borderRadius = props.borderRadius || 2;
        return baseStyle;
      case buttonType.NAVIGATION:
        baseStyle.backgroundColor = props.isSelected ? secondaryColor : transparent;
        baseStyle.color = props.isSelected? primaryColor : textColorLight;
        baseStyle.borderRadius = 0;
        baseStyle.paddingLeft = 20;
        baseStyle.paddingRight = 0;
        return baseStyle;
      default: return {}
    }
  }

  const getBaseStyle = () => {
    const backgroundColor = props.disabled ? props.disabledBackgroundColor || defaultDisabledBackgroundColor : props.backgroundColor || primaryColor;
    const color = props.disabled ? props.disabledColor || defaultDisabledTextColor : props.color || textColorDark;
    const borderColor = props.borderColor || transparent;
    const borderRadius = props.borderRadius || maxBorderRadius;
    const width = props.width || defaultButtonWidth;
    const height = props.height || defaultButtonHeight;
    return {
      backgroundColor,
      color,
      borderRadius,
      borderColor,
      height,
      fontFamily: defaultFontFamilyBold,
      fontSize: props.fontSize || 14,
      paddingLeft: 0,
      paddingRight: 0,
      borderWidth: 0,
      width,
      ...props.styles
    }
  }

  const getSectionIcon = (props: ButtonProps) => {
    // TODO: Add additional conditions for buttons with icon
    if(props.title == "ログアウト") {
      return <Box style={{ width: '24px', height: 'auto' }}>
              {getImage(props.isSelected ? props.icon?.activeIcon : props.icon?.defaultIcon)}
            </Box>
    } 
    if (props.variant === buttonType.NAVIGATION) {
      return getImage(props.isSelected ? props.icon?.activeIcon : props.icon?.defaultIcon);
    } else if (props.icon?.defaultIcon) {
      return getImage(props.icon?.defaultIcon);
    } else {
      return undefined;
    }
  }

  const getImage = (src: string | undefined) => {
    return <Image src={src} alt="Icon"/>
  }

  const getTextAlignmentByVariant = (variant: string | undefined) => {
    switch (variant) {
      case buttonType.NAVIGATION: return { display: "flex", justifyContent: "flex-start", alignItems: "center", ...props.styles};
      default: return {...props.styles};
    }
  }

	return (
    <MantineButton
    styles={_ => ({root: getStyleByVariant()})}
    style={getTextAlignmentByVariant(props.variant)}
    disabled={props.disabled}
    leftSection={getSectionIcon(props)}
    className={props.className}
    type={props.type || "button"}
    onClick={props.onClickEvent}
    loading={props.isLoading}>
      { props.title }
    </MantineButton>
	);
}

export default Button;
